import NotificationSummary from 'containers/Chats/NotificationSummary'
import igotech from 'assets/warehouse/igotech/interior.png'
import { selectUser } from 'containers/Login/loginSlice'
import { LOCATION_STATES } from '../../utils/constants'
import { POPUPS as HOME_POPUPS } from 'containers/Home'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import xmagazyn from 'assets/img/xmagazyn.webp'
import { useHistory } from 'react-router-dom'
import mmstore from 'assets/img/mmstore.png'
import vipbox from 'assets/img/vipbox.webp'
import magbox from 'assets/img/magbox.webp'
import htbox from 'assets/img/htbox.webp'
import Popups, { POPUPS } from './Popups'
import { useSelector } from 'react-redux'
import Shortcuts from './Shortcuts'
import Favorite from './Favorite'
import './style.scss'

const type = process.env.REACT_APP_TYPE

const Dashboard = () => {
  const user = useSelector(selectUser)

  const { push } = useHistory()
  const { t } = useTranslation('dashboard')
  const showPopup = p => {
    push(window.location.pathname, LOCATION_STATES.popup(p))
  }

  return (
    <div className='dashboard'>
      <Popups />
      <div className='dashboard__title'>
        <h2>{t('messages')}</h2>
        <div
          onClick={() => {
            push('/chat')
          }}>
          <span>{t('goTo')}</span>
          <i className='icon icon--arrow-right'></i>
        </div>
      </div>
      <NotificationSummary />

      {user?.showFavorites
        ? <>
          <div className='dashboard__title'>
            <h2>{t('favorites')}</h2>
            <div
              onClick={() => {
                showPopup({ type: POPUPS.editFavorite })
              }}>
              <span>{t('edit')}</span>
              <i className='icon icon--arrow-right'></i>
            </div>
          </div>
          <Favorite />
          <div className='dashboard__title'>
            <h2>{t('shortcuts')}</h2>
            <div
              onClick={() => {
                showPopup({ type: POPUPS.editShortcuts })
              }}>
              <span>{t('edit')}</span>
              <i className='icon icon--arrow-right'></i>
            </div>
          </div>
          <Shortcuts />
        </>
        : <>
          <div className='dashboard__title --center'>
            <h2>{t('welcomeMessage')}</h2>
          </div>

          <div className='dashboard__favorite --center'>
            <div className='favorite__card favorite__card__commercial --right'>
              <div className='favorite__card__column'>
                <h2>{t(`noStorageYetQuestion.${type}`)}</h2>
                <ArrowBtn
                  text={t('rentStorage')}
                  className={type === 'rze01' ? '--black' : ''}
                  action={() => {
                    push((type === 'mm' || type === 'box') ? '/categories' : '/home')
                  }}
                />
              </div>
              <img
                alt=''
                decoding='sync'
                src={type === 'mm'
                  ? magbox
                  : type === 'ldz01'
                    ? vipbox
                    : type === 'ldz02'
                      ? xmagazyn
                      : type === 'chr01'
                        ? igotech
                        : htbox}
              />
            </div>
          </div>

          {type === 'mm' && <div className='dashboard__favorite --center'>
            <div className='favorite__card favorite__card__commercial --left --smaller'>
              <img
                alt=''
                decoding='sync'
                src={mmstore}
              />
              <div className='favorite__card__column'>
                <h2>{t('heardAboutStorageService')}</h2>
                <ArrowBtn
                  text={t('storeWithMagstore')}
                  action={() => {
                    showPopup(HOME_POPUPS.magStore)
                  }}
                />
              </div>
            </div>
          </div>}
        </>}
    </div>
  )
}

export default Dashboard